/**
 * Care Refresh + Inline Accessories - Add-to-cart handler
 * Presents care refresh modal when enabled, and handles inline accessory checkboxes.
 * When a bundle tier is selected, opens Care modal and adds the bundle in the background.
 */
(function () {
  'use strict';
  if (window.__d1CareRefreshScriptLoaded) return;
  window.__d1CareRefreshScriptLoaded = true;

  var selectedPlan = null;
  var pendingFormEl = null;
  var pendingBundlePromise = null;
  var pendingBundleResponse = null;
  var pendingIsBundle = false;
  var modalConfirmed = false;

  var BENEFIT_ICON =
    '<span class="cr-modal__benefit-icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13.3 4L6 11.3 2.7 8" stroke="#1a7f37" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

  function getCareState() {
    var enabled = window.d1CareRefresh && window.d1CareRefresh.enabled;
    var el = document.getElementById('CareRefreshModal');
    // Shell modal (collection pages) is enabled per-form via data-d1-care-refresh.
    if (!enabled && el && el.hasAttribute('data-cr-shell')) {
      return { enabled: false, modal: el, shell: true };
    }
    return { enabled: !!enabled, modal: enabled ? el : null, shell: false };
  }

  function getFormCareConfig(formEl) {
    if (!formEl) return null;
    var scope = formEl.closest('product-form') || formEl;
    var node = formEl.querySelector('[data-d1-care-refresh]') || scope.querySelector('[data-d1-care-refresh]');
    if (!node) return null;
    try {
      var raw = node.tagName === 'SCRIPT' ? node.textContent : node.getAttribute('data-d1-care-refresh');
      var cfg = JSON.parse(raw);
      if (!cfg || !cfg.plans || (!cfg.plans['1yr'] && !cfg.plans['2yr'])) return null;
      return cfg;
    } catch (err) {
      console.warn('Care Refresh config parse failed', err);
      return null;
    }
  }

  function paintPlanPrice(btn, planCfg) {
    var priceEl = btn.querySelector('[data-cr-price]') || btn.querySelector('.cr-modal__option-price');
    var badge = btn.querySelector('[data-cr-free-badge]');
    var meta = btn.querySelector('[data-cr-meta]');
    if (!planCfg) return;

    if (planCfg.free) {
      btn.setAttribute('data-cr-free', 'true');
      if (priceEl) {
        priceEl.replaceChildren();
        if (planCfg.price) {
          var was = document.createElement('s');
          was.className = 'cr-modal__option-was';
          was.textContent = planCfg.price;
          priceEl.appendChild(was);
        }
        var free = document.createElement('span');
        free.className = 'cr-modal__option-free';
        free.textContent = 'FREE';
        priceEl.appendChild(free);
      }
      if (badge) badge.hidden = false;
      if (meta) meta.textContent = 'Included free with this product';
      return;
    }

    btn.removeAttribute('data-cr-free');
    if (priceEl && planCfg.price) priceEl.textContent = planCfg.price;
    if (badge) badge.hidden = true;
    if (meta) {
      meta.textContent = btn.getAttribute('data-cr-plan') === '2yr'
        ? '4 replacements · 2 year warranty'
        : '2 replacements · 1 year warranty';
    }
  }

  function addButtonLabel(plan, isFree) {
    if (plan === 'none') return 'Add to Cart';
    var planLabel = plan === '2yr' ? '2-Year' : '1-Year';
    if (isFree) return 'Add to Cart with Free ' + planLabel + ' Care Refresh';
    return 'Add to Cart with ' + planLabel + ' Care Refresh';
  }

  function selectDefaultPlan() {
    var m = modal || document.getElementById('CareRefreshModal');
    if (!m) return;
    var freeBtn = m.querySelector('[data-cr-select][data-cr-free="true"]:not([hidden])');
    if (freeBtn) freeBtn.click();
  }

  function applyCareConfig(config) {
    var m = modal || document.getElementById('CareRefreshModal');
    if (!m || !config) return false;
    modal = m;

    var titleEl = m.querySelector('[data-cr-title]') || m.querySelector('.cr-modal__title');
    if (titleEl && config.title) {
      titleEl.textContent = 'Protect Your ' + config.title;
    }

    ['1yr', '2yr'].forEach(function (plan) {
      var btn = m.querySelector('[data-cr-select][data-cr-plan="' + plan + '"]');
      if (!btn) return;
      var planCfg = config.plans && config.plans[plan];
      if (!planCfg || !planCfg.variantId) {
        btn.hidden = true;
        btn.setAttribute('data-cr-variant-id', '');
        btn.removeAttribute('data-cr-free');
        return;
      }
      btn.hidden = false;
      btn.setAttribute('data-cr-variant-id', String(planCfg.variantId));
      paintPlanPrice(btn, planCfg);
    });

    var plan1 = config.plans && config.plans['1yr'];
    var repEl = m.querySelector('[data-cr-benefit-rep]');
    if (repEl) {
      if (plan1 && plan1.repFee) {
        repEl.hidden = false;
        repEl.innerHTML = BENEFIT_ICON + ' Replacement fee from ' + plan1.repFee;
      } else {
        repEl.hidden = true;
        repEl.textContent = '';
      }
    }
    var flyEl = m.querySelector('[data-cr-benefit-fly]');
    if (flyEl) {
      if (config.isDrone && plan1 && plan1.flyFee) {
        flyEl.hidden = false;
        flyEl.innerHTML = BENEFIT_ICON + ' Flyaway fee from ' + plan1.flyFee;
      } else {
        flyEl.hidden = true;
        flyEl.textContent = '';
      }
    }

    // Refresh option NodeList after show/hide
    options = m.querySelectorAll('[data-cr-select]');
    return true;
  }

  var modal = null;
  var options = [];
  var addBtn = null;
  var closeBtns = [];
  var btnText = null;
  var modalBound = false;
  var modalAbortController = null;

  function setProductFormBusy(productForm, busy) {
    if (!productForm) return;
    productForm.d1AddingToCart = !!busy;
    var submit = productForm.querySelector('[type="submit"]');
    if (submit) {
      submit.toggleAttribute('disabled', !!busy);
      submit.setAttribute('aria-busy', busy ? 'true' : 'false');
      submit.classList.toggle('loading', !!busy);
      var spinner = submit.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
    }

    var sticky = document.querySelector('[data-d1-sticky-submit]');
    if (sticky) {
      sticky.toggleAttribute('disabled', !!busy);
      sticky.classList.toggle('loading', !!busy);
      sticky.setAttribute('aria-busy', busy ? 'true' : 'false');
      var stickySpinner = sticky.querySelector('.loading-overlay__spinner, .loading__spinner');
      if (stickySpinner) {
        stickySpinner.style.display = busy ? 'flex' : 'none';
        stickySpinner.classList.toggle('hidden', !busy);
      }
    }
  }

  function collectInlineAccessories() {
    var ids = [];
    document.querySelectorAll('[data-d1-inline-acc-cb]:checked').forEach(function (cb) {
      if (cb.disabled || cb.closest('[hidden]')) return;
      var vid = parseInt(cb.getAttribute('data-variant-id'), 10);
      if (vid) ids.push(vid);
    });
    return ids;
  }

  function clearInlineAccessories() {
    document.querySelectorAll('[data-d1-inline-acc-cb]:checked').forEach(function (cb) {
      cb.checked = false;
    });
  }

  function hasBundleAdd() {
    return (
      typeof window.d1BundleTiers !== 'undefined' &&
      typeof window.d1BundleTiers.hasBundleAdd === 'function' &&
      window.d1BundleTiers.hasBundleAdd()
    );
  }

  function openModal() {
    var m = modal || document.getElementById('CareRefreshModal');
    if (!m) return;
    // Escape product-column overflow/transform so the modal covers the viewport
    if (m.parentElement !== document.body) {
      document.body.appendChild(m);
    }
    modal = m;
    modalConfirmed = false;
    m.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    selectDefaultPlan();
  }

  function resetModalUi() {
    selectedPlan = null;
    options.forEach(function (o) { o.classList.remove('is-selected'); });
    if (addBtn) addBtn.disabled = true;
    if (btnText) btnText.textContent = 'Select an option to continue';
  }

  function closeModal() {
    var m = modal || document.getElementById('CareRefreshModal');
    if (!m) return;
    m.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetModalUi();
  }

  function getCartAndSections() {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sections = (cart && cart.getSectionsToRender)
      ? cart.getSectionsToRender().map(function (s) { return s.id; })
      : [];
    return { cart: cart, sections: sections };
  }

  function postCartItems(items, ref) {
    var payload = { items: items };
    if (ref.sections.length) {
      payload.sections = ref.sections;
      payload.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function renderCart(response) {
    var ref = getCartAndSections();
    if (!response) return;
    clearInlineAccessories();
    if (ref.cart) {
      if (ref.cart.classList.contains('is-empty')) ref.cart.classList.remove('is-empty');
      ref.cart.renderContents(response);
    } else {
      window.location = window.routes.cart_url;
    }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'care-refresh',
        cartData: response,
      });
    }
  }

  function batchAdd(items, callback) {
    var ref = getCartAndSections();
    return postCartItems(items, ref)
      .then(function (response) {
        if (response.status) throw new Error(response.description || 'Add failed');
        renderCart(response);
        if (callback) callback(null, response);
        return response;
      })
      .catch(function (err) {
        if (items.length > 1) {
          return postCartItems([items[0]], ref)
            .then(function (fallback) {
              if (fallback.status) throw new Error(fallback.description || 'Fallback add failed');
              renderCart(fallback);
              if (typeof window.d1ShowToast === 'function') {
                window.d1ShowToast('Some accessories were unavailable. Added the main product only.');
              }
              if (callback) callback(null, fallback);
              return fallback;
            })
            .catch(function (fallbackErr) {
              console.error('Add to cart fallback error:', fallbackErr);
              if (callback) callback(fallbackErr);
              throw fallbackErr;
            });
        }
        console.error('Add to cart error:', err);
        if (callback) callback(err);
        throw err;
      });
  }

  function buildPayload(formEl, careVariantId) {
    var mainVariantId = parseInt(formEl.querySelector('[name=id]').value, 10);
    var quantityInput = formEl.querySelector('[name=quantity]');
    var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

    // Keep No Extras lines distinct from bundled mains (Shopify merges identical props).
    var mainProps = { _d1_bundle_selection: 'none' };
    if (window.D1AccessoryAtc && window.D1AccessoryAtc.stampPreorderProps) {
      var submit = formEl.querySelector('[data-d1-main-submit], [name="add"]');
      window.D1AccessoryAtc.stampPreorderProps(
        mainProps,
        window.D1AccessoryAtc.isPreorderControl(submit),
      );
    }
    var items = [
      {
        id: mainVariantId,
        quantity: qty,
        properties: mainProps,
      },
    ];

    if (careVariantId) {
      items.push({ id: parseInt(careVariantId, 10), quantity: qty });
    }

    var accIds = collectInlineAccessories();
    accIds.forEach(function (id) {
      items.push({ id: id, quantity: 1, properties: { _d1_accessory_upsell: 'true' } });
    });

    return items;
  }

  function careAvailableForForm(formEl) {
    var formCare = getFormCareConfig(formEl);
    if (formCare) {
      if (!modalBound) bindModal();
      applyCareConfig(formCare);
      return !!document.getElementById('CareRefreshModal');
    }
    var care = getCareState();
    return !!(care.enabled && care.modal);
  }

  function openForBundle(productForm, formEl) {
    if (!productForm || !formEl) return;
    if (!modalBound) bindModal();
    if (!careAvailableForForm(formEl)) return false;

    pendingFormEl = productForm;
    pendingIsBundle = true;
    pendingBundleResponse = null;
    pendingBundlePromise = null;
    setProductFormBusy(productForm, true);
    openModal();
    startSilentBundleAdd(formEl).catch(function () {});
    return true;
  }

  /** Same as openForBundle, but uses pre-built cart lines (bundle listing ATC). */
  function openForBundleItems(productForm, items) {
    if (!productForm || !items || items.length < 2) return false;
    if (!modalBound) bindModal();
    var formEl = productForm.querySelector
      ? productForm.querySelector('form[data-type="add-to-cart-form"]') || productForm.querySelector('form')
      : null;
    if (formEl && !careAvailableForForm(formEl) && !getCareState().enabled) return false;
    if (!document.getElementById('CareRefreshModal')) return false;
    if (formEl) {
      var formCare = getFormCareConfig(formEl);
      if (formCare) applyCareConfig(formCare);
    }

    pendingFormEl = productForm;
    pendingIsBundle = true;
    pendingBundleResponse = null;
    pendingBundlePromise = null;
    setProductFormBusy(productForm, true);
    openModal();
    startSilentBundleAddItems(items).catch(function () {});
    return true;
  }

  function startSilentBundleAdd(formEl) {
    pendingBundleResponse = null;
    pendingBundlePromise = null;
    if (!window.d1BundleTiers || typeof window.d1BundleTiers.buildPayload !== 'function') {
      return Promise.resolve(null);
    }
    var items = window.d1BundleTiers.buildPayload(formEl);
    if (!items || items.length < 2) return Promise.resolve(null);
    return startSilentBundleAddItems(items);
  }

  function startSilentBundleAddItems(items) {
    pendingBundleResponse = null;
    pendingBundlePromise = null;
    if (!items || items.length < 2) return Promise.resolve(null);
    if (!window.d1BundleTiers || typeof window.d1BundleTiers.batchAdd !== 'function') {
      return Promise.resolve(null);
    }

    pendingBundlePromise = window.d1BundleTiers
      .batchAdd(items, null, { silent: true })
      .then(function (response) {
        pendingBundleResponse = response;
        return response;
      })
      .catch(function (err) {
        console.error('Background bundle add failed:', err);
        throw err;
      });

    return pendingBundlePromise;
  }

  function addCareOnly(careVariantId, qty) {
    if (!careVariantId) return Promise.resolve(pendingBundleResponse);
    var ref = getCartAndSections();
    return postCartItems([{ id: parseInt(careVariantId, 10), quantity: qty || 1 }], ref).then(function (response) {
      if (response.status) throw new Error(response.description || 'Care add failed');
      pendingBundleResponse = response;
      return response;
    });
  }

  function finishAndShowCart() {
    var response = pendingBundleResponse;
    pendingFormEl = null;
    pendingIsBundle = false;
    pendingBundlePromise = null;
    closeModal();
    if (response) {
      renderCart(response);
    } else if (window.d1BundleTiers && typeof window.d1BundleTiers.openCartWithResponse === 'function') {
      // Fallback: refresh cart drawer from current cart state via a no-op re-render path
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart && typeof cart.renderContents === 'function') {
        fetch(window.routes.cart_url + '.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            // sections may be missing; still try to open drawer
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            if (typeof cart.open === 'function') cart.open();
            publish && publish(PUB_SUB_EVENTS.cartUpdate, { source: 'care-refresh', cartData: cartData });
          })
          .catch(function () {});
      }
    }
  }

  function bindModal() {
    var nextModal = document.getElementById('CareRefreshModal');
    if (modalBound && modal === nextModal) return;
    if (modalAbortController) modalAbortController.abort();
    modalAbortController = null;
    modalBound = false;
    modal = nextModal;
    if (!modal) return;

    modalAbortController = new AbortController();
    var signal = modalAbortController.signal;
    modalBound = true;

    options = modal.querySelectorAll('[data-cr-select]');
    addBtn = modal.querySelector('[data-cr-add]');
    closeBtns = modal.querySelectorAll('[data-cr-close]');
    btnText = modal.querySelector('.cr-modal__btn-text');

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        selectedPlan = opt.getAttribute('data-cr-variant-id');
        if (addBtn) addBtn.disabled = false;

        var plan = opt.getAttribute('data-cr-plan');
        if (btnText) {
          btnText.textContent = addButtonLabel(plan, opt.getAttribute('data-cr-free') === 'true');
        }
      }, { signal: signal });
    });

    function onDismissWithoutConfirm() {
      // Bundle may already be in cart from the background add — show cart.
      if (pendingIsBundle && !modalConfirmed) {
        var formEl = pendingFormEl;
        var wait = pendingBundlePromise || Promise.resolve(pendingBundleResponse);
        wait
          .catch(function () { return pendingBundleResponse; })
          .then(function () {
            pendingFormEl = formEl;
            finishAndShowCart();
            if (formEl) setProductFormBusy(formEl, false);
          });
        return;
      }
      closeModal();
      if (pendingFormEl) setProductFormBusy(pendingFormEl, false);
      pendingFormEl = null;
      pendingIsBundle = false;
      pendingBundlePromise = null;
      pendingBundleResponse = null;
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', onDismissWithoutConfirm, { signal: signal });
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) onDismissWithoutConfirm();
    }, { signal: signal });

    document.addEventListener('keyup', function (e) {
      var m = modal || document.getElementById('CareRefreshModal');
      if (m && e.key === 'Escape' && m.getAttribute('aria-hidden') === 'false') {
        onDismissWithoutConfirm();
      }
    }, { signal: signal });

    addBtn.addEventListener('click', function () {
      if (!pendingFormEl) return;
      if (pendingFormEl.d1AddingToCart && !pendingIsBundle) return;

      modalConfirmed = true;
      addBtn.disabled = true;
      if (btnText) btnText.textContent = 'Adding to cart\u2026';
      setProductFormBusy(pendingFormEl, true);

      var careId = selectedPlan || null;
      var formEl = pendingFormEl;
      var qtyInput = formEl.querySelector('[name=quantity]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (pendingIsBundle) {
        var wait = pendingBundlePromise || Promise.resolve(pendingBundleResponse);
        wait
          .then(function () {
            return addCareOnly(careId, qty);
          })
          .then(function () {
            finishAndShowCart();
          })
          .catch(function (err) {
            console.error('Bundle + care add error:', err);
            if (typeof window.d1ShowToast === 'function') {
              window.d1ShowToast(err && err.message ? err.message : 'Could not finish adding to cart.');
            }
            // Still try to show whatever made it into the cart
            finishAndShowCart();
          })
          .finally(function () {
            setProductFormBusy(formEl, false);
          });
        return;
      }

      var items = buildPayload(formEl, careId);
      batchAdd(items, function (err) {
        if (!err) closeModal();
      }).finally(function () {
        setProductFormBusy(formEl, false);
        pendingFormEl = null;
      }).catch(function () {});
    }, { signal: signal });
  }

  window.d1CareRefresh = window.d1CareRefresh || { enabled: false };
  window.d1CareRefresh.openForBundle = openForBundle;
  window.d1CareRefresh.openForBundleItems = openForBundleItems;

  var submitDelegateBound = false;

  function isBundleListingAtcPage() {
    var el = document.getElementById('d1-bundle-listing-atc-config');
    if (!el) return false;
    try {
      var c = JSON.parse(el.textContent);
      return !!(c && c.parentVariantId && c.accessoryIds && c.accessoryIds.length);
    } catch (_) {
      return false;
    }
  }

  function onProductFormSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    // Listing pages expand to parent + accessories via d1-bundle-listing-atc.js
    if (isBundleListingAtcPage()) return;

    var pf = form.closest('product-form') || form;
    if (pf.d1AddingToCart) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    if (!modalBound) bindModal();
    var formCare = getFormCareConfig(form);
    var care = getCareState();
    var careReady = false;
    if (formCare) {
      applyCareConfig(formCare);
      careReady = !!document.getElementById('CareRefreshModal');
    } else {
      careReady = !!(care.enabled && care.modal);
    }
    var bundleSelected = hasBundleAdd();

    // Bundle + Care: owned by bundle-tiers.js → d1CareRefresh.openForBundle.
    // Keep a fallback here in case another submit path reaches us first.
    if (bundleSelected && careReady) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openForBundle(pf, form);
      return;
    }

    // Bundle without Care: let bundle-tiers.js handle it.
    if (bundleSelected) return;

    var accIds = collectInlineAccessories();

    if (careReady) {
      if (pf.d1SkipCareModal) {
        pf.d1SkipCareModal = false;
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      pendingFormEl = pf;
      pendingIsBundle = false;
      pendingBundlePromise = null;
      pendingBundleResponse = null;
      openModal();
      return;
    }

    if (accIds.length > 0) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var items = buildPayload(form, null);
      setProductFormBusy(pf, true);
      batchAdd(items).finally(function () {
        setProductFormBusy(pf, false);
      }).catch(function () {});
    }
  }

  function bindProductForms() {
    // ponytail: one capture listener covers PDP, collection cards, and facet re-renders
    if (submitDelegateBound) return;
    submitDelegateBound = true;
    document.addEventListener('submit', onProductFormSubmit, true);
  }

  function init() {
    bindModal();
    window.d1CareRefresh = window.d1CareRefresh || { enabled: false };
    window.d1CareRefresh.openForBundle = openForBundle;
    window.d1CareRefresh.openForBundleItems = openForBundleItems;
    bindProductForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('product-info:loaded', init);
})();
